import React from 'react';
import { usePortfolio } from '../../context/PortfolioContext';
import { X, Printer, Download, Mail, MapPin, Globe } from 'lucide-react';

export const DigitalResumeModal: React.FC = () => {
  const { isResumeModalOpen, setIsResumeModalOpen, notify } = usePortfolio();

  if (!isResumeModalOpen) return null;

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPDF = () => {
    notify('Preparing digital resume download...', 'info');
    setTimeout(() => {
      window.print();
    }, 500);
  };

  return (
    <div className="modal-overlay active" onClick={() => setIsResumeModalOpen(false)}>
      <div
        className="modal-container"
        style={{ maxWidth: '850px' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="modal-close-btn"
          onClick={() => setIsResumeModalOpen(false)}
          aria-label="Close modal"
        >
          <X size={20} />
        </button>

        <div className="modal-body" style={{ background: 'var(--bg-card)', borderRadius: '16px', border: '1px solid var(--border-color)' }}>
          {/* Action Bar */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1rem' }}>
            <h3 style={{ color: 'var(--text-title)', fontSize: '1.4rem' }}>Digital Resume</h3>
            <div style={{ display: 'flex', gap: '0.8rem' }}>
              <button className="btn btn-secondary" onClick={handlePrint} style={{ padding: '0.5rem 1rem', fontSize: '0.85rem' }}>
                <Printer size={15} />
                <span>Print</span>
              </button>
              <button className="btn btn-primary" onClick={handleDownloadPDF} style={{ padding: '0.5rem 1rem', fontSize: '0.85rem' }}>
                <Download size={15} />
                <span>Save as PDF</span>
              </button>
            </div>
          </div>

          {/* Resume Header */}
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h1 style={{ fontSize: '2.2rem', color: 'var(--text-title)', fontWeight: 800 }}>LORENZ SALDIVAR</h1>
            <h2 style={{ fontSize: '1.1rem', color: 'var(--accent-cyan)', fontWeight: 700, marginBottom: '1rem' }}>
              BS Information Technology Graduate (Class of 2026) | Web Developer & IT Technical Support
            </h2>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', flexWrap: 'wrap', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}><Mail size={14} /> lorenzmanillasaldivar@gmail.com</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}><Globe size={14} /> github.com/Zenerol</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}><MapPin size={14} /> Pongol, Libona, Bukidnon • Philippines</span>
            </div>
          </div>

          {/* Summary */}
          <div style={{ marginBottom: '1.8rem' }}>
            <h4 style={{ color: 'var(--accent-blue)', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.4rem', marginBottom: '0.8rem', fontSize: '1.1rem' }}>
              PROFESSIONAL SUMMARY
            </h4>
            <p style={{ color: 'var(--text-main)', fontSize: '0.92rem', lineHeight: '1.6' }}>
              Highly motivated recent BSIT graduate from Tagoloan Community College (Class of 2026) specializing in Web Development and IT Technical Support. Experienced Backend Developer for IJERT-published Capstone project (Lumichat) and completed a 3-month IT Support internship at Speakify Teams Corp. Enthusiastic about leveraging AI-Assisted development (Claude Code, AntiGravity, Codex) with React, TypeScript, and PHP/Laravel to build clean, maintainable web applications.
            </p>
          </div>

          {/* Core Competencies */}
          <div style={{ marginBottom: '1.8rem' }}>
            <h4 style={{ color: 'var(--accent-blue)', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.4rem', marginBottom: '0.8rem', fontSize: '1.1rem' }}>
              CORE TECHNICAL SKILLS
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', fontSize: '0.9rem', color: 'var(--text-main)' }}>
              <div><strong>Web Engineering:</strong> React, TypeScript, HTML5/CSS3, PHP/Laravel, REST APIs</div>
              <div><strong>IT Infrastructure:</strong> Network Troubleshooting, Hardware Maintenance, OS Admin</div>
              <div><strong>Tools & Databases:</strong> MySQL, Supabase, Cloudflare, Git/GitHub, VS Code</div>
              <div><strong>AI Workflow:</strong> Claude Code, Google AntiGravity, OpenAI Codex</div>
            </div>
          </div>

          {/* Education & Experience */}
          <div>
            <h4 style={{ color: 'var(--accent-blue)', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.4rem', marginBottom: '0.8rem', fontSize: '1.1rem' }}>
              EDUCATION & PRACTICAL EXPERIENCE
            </h4>
            
            <div style={{ marginBottom: '1.2rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--card-heading)', fontWeight: 700 }}>
                <span>Tagoloan Community College — BS Information Technology (BSIT)</span>
                <span>Graduated 2026</span>
              </div>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>College of Information Technology • Backend Developer for Lumichat Capstone (Published in IJERT Journal)</p>
            </div>

            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--card-heading)', fontWeight: 700 }}>
                <span>Speakify Teams Corp. — IT Technical Support & Admin Data Specialist</span>
                <span>3 Months Internship</span>
              </div>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Hardware & Network Troubleshooting, Systems Maintenance & Administrative Data Entry</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
